import React from 'react';
import { connect } from 'react-redux';

//Actions
import { novoatualiza, zeracodigoselecionado, zeranovoatualiza } from '../../../../actions/produto/codigoPromocional';

//Components
import FormCadastro from '../../../../containers/forms/automacao/FormCadastro';

//Utils
import { getCamposInitialValues } from '../../../../components/forms/utils/toolsforms';
import { getEvento } from '../../../../utils/eventosession';

class FormProdutos extends React.Component {

    handleSubmit = (form) => {
        const evento = getEvento();
        const dados = {
            ...form,
            iddescontocodigo: this.props.codigoselecionado?this.props.codigoselecionado.iddescontocodigo:0,
            idpromotora: evento.idpromotora,
            idevento: evento.idevento
        }        
        
        this.props.novoatualiza(dados);
    }

    handleValidacao = (values) => {

        let errors = {};
        

        return errors;
    }

    handleDadosForm = () => {
        return [
            {
                formsessao: 'Descontos de Pacotes',
                rows: [
                    [
                        { md: 4, type: "text", name: 'codigo', label: 'Código', component: 'text' },
                        { md: 4, type: "text", name: 'descricao', label: 'Descrição', component: 'text'}                        
                    ],
                    [
                        { md: 4, type: "text", name: 'qtde', label: 'Quantidade', component: 'text' },
                        { md: 4, type: "text", name: 'datalimite', label: 'Data de Validade', component: 'calendario'},
                        { md: 4, type: "text", name: 'valor', label: 'Valor de Desconto', component: 'text' },
                    ], [
                        { md: 4, type: "text", name: 'percentual', label: 'Percentual de Desconto', component: 'text'},
                        { md: 4, type: "text", name: 'valorsocio', label: 'Valor de Desconto (Sócios)', component: 'text' },
                        { md: 4, type: "text", name: 'vernocongresso', label: 'Produto de Rótulos:', component: 'text'},
                    ], [
                        { md: 4, type: "text", name: 'valorsocio_int', label: 'Valor de Desconto Internacional (Sócio)', component: 'text'},
                        { md: 4, type: "text", name: 'valor_int', label: 'Valor de Desconto Internacional', component: 'text'},
                        { md: 4, type: "text", name: 'grupodesconto', label: 'Grupo de Desconto', component: 'select'},
                    ]
                ]
            }, {
                formsessao: 'Descontos Por Quantidade De Inscritos',
                rows: [
                    [
                        { md: 4, type: "text", name: 'qtdeinicial', label: 'Quantidade Inicial', component: 'texto' },
                        { md: 4, type: "text", name: 'qtdefinal', label: 'Quantidade Final', component: 'texto' },
                        { md: 4, type: "text", name: 'percentual', label: 'Percentual de Desconto', component: 'texto' }
                    ], [
                        { md: 4, type: "text", name: 'datalimitegrupo', label: 'Data de Validade', component: 'texto' },
                    ]
                ]
            }
        ];
    }

    render() {
        const selecionado = Object.keys(this.props.codigoselecionado).length?this.props.codigoselecionado:{};        
        return (
            <FormCadastro
                handleSubmit={this.handleSubmit}
                handleValidacao={this.handleValidacao}
                formcampos={[...this.handleDadosForm()]}
                initialValues={getCamposInitialValues(this.handleDadosForm(), selecionado)}
                btosubmitlabel="Confirmar"
                handleResetReducer={this.props.zeracodigoselecionado}
                resultcadastro={this.props.resultcadastro&&this.props.resultcadastro.iddescontocodigo}
                handleResetAlertReducer={this.props.zeranovoatualiza}
            />
        );
    }
}

const mapStateToProps = (state) => {
    return {        
        pendingTasks: state.pendingTasks,
        codigoselecionado: state.reducerCodigoPromocionalSelecionado,
        resultcadastro: state.reducerCodigoPromocionalNovoAtualiza
    }
}

export default connect(mapStateToProps, { novoatualiza, zeracodigoselecionado, zeranovoatualiza })(FormProdutos);